import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzPatchScanWebComponent } from './component/GzPatchScanWebComponent';
import { translateFn } from '../../../../utils/translator.helper';
import { CreateTaskRequest } from '../../types';
import { getFormattedDateForTask } from '../../../networkAppContainer/helpers/utils';

export class PatchScanPopUp extends NetworkBasePopUp<GzPatchScanWebComponent> {
  protected transformToTaskTarget = true;
  protected title = translateFn('Patch scan');
  protected extraDialogConfigs = {
    isWindow: false,
  };

  protected customSetup() {
    this.popUpContent = new GzPatchScanWebComponent();
  }

  protected handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const payload: CreateTaskRequest = {
      settings: {
        targets: this.data.targets || [],
        taskName: translateFn('Patch scan ') + getFormattedDateForTask(),
        type: Constants.Tasks.Endpoints.TASK_TYPE_PATCH_SCAN_PARENT,
      },
    };

    return this.createTask(payload);
  }
}
